var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsFilledHome24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CB17BFAA-D034-44E9-A1A4-11CEB7FCF84C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Filled/home_24px"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "\\uD83C\\uDF08-Icon-Color"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(0.000000, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.78878893,3.2182699 L2.68512111,7.4217301 L2.68512111,11.9584775 C2.68512111,12.2030881 2.88341714,12.4013841 3.12802768,12.4013841 L6.2300346,12.3933564 C6.47377988,12.3921377 6.67072969,12.1941981 6.67072664,11.9504498 L6.67072664,9.30103806 C6.67072664,9.05642752 6.86902267,8.85813149 7.11363322,8.85813149 L8.88525952,8.85813149 C9.12987006,8.85813149 9.32816609,9.05642752 9.32816609,9.30103806 L9.32816609,11.9485121 C9.32779826,12.0662179 9.37429906,12.1792288 9.45740006,12.2625895 C9.54050105,12.3459502 9.65336634,12.3928033 9.77107266,12.3928028 L12.8719723,12.4013841 C13.1165829,12.4013841 13.3148789,12.2030881 13.3148789,11.9584775 L13.3148789,7.41868512 L8.21231834,3.2182699 C8.0887186,3.11864217 7.91238867,3.11864217 7.78878893,3.2182699 Z M15.850519,6.07529412 L13.5363322,4.16775087 L13.5363322,0.333564014 C13.5363322,0.150106104 13.3876102,0.00138408304 13.2041522,0.00138408304 L11.6539792,0.00138408304 C11.4705213,0.00138408304 11.3217993,0.150106104 11.3217993,0.333564014 L11.3217993,2.34352941 L8.84346021,0.30449827 C8.35296125,-0.0991323236 7.64537785,-0.0991323236 7.15487889,0.30449827 L0.147820069,6.07529412 C0.079887244,6.13144265 0.0370524502,6.21228621 0.028745589,6.30002743 C0.0204387278,6.38776865 0.0473407947,6.47521452 0.103529412,6.54311419 L0.809411765,7.40124567 C0.86544838,7.46938344 0.94628795,7.51243173 1.03410144,7.5208963 C1.12191492,7.52936088 1.20948875,7.50254641 1.27750865,7.44636678 L7.78878893,2.0833218 C7.91238867,1.98369407 8.0887186,1.98369407 8.21231834,2.0833218 L14.7238754,7.44636678 C14.7917751,7.5025554 14.879221,7.52945747 14.9669622,7.5211506 C15.0547034,7.51284374 15.135547,7.47000895 15.1916955,7.40207612 L15.8975779,6.54394464 C15.9537094,6.47564946 15.9803027,6.38779695 15.9714704,6.29983691 C15.962638,6.21187686 15.9191085,6.13106563 15.850519,6.07529412 L15.850519,6.07529412 Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFilledHome24Px);
export default __webpack_public_path__ + "static/media/Icons_Filled_home_24px.faf83b14.svg";
export { ForwardRef as ReactComponent };